import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-patientInfo",
  "use": "icon-icon-patientInfo-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-patientInfo\">\n<circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#90AFDF\" fill-opacity=\"0.75\" />\n<path d=\"M12.0202 12.392C14.1678 12.392 15.9085 10.6513 15.9085 8.50376C15.9085 6.35618 14.1678 4.61548 12.0202 4.61548C9.87262 4.61548 8.13191 6.35618 8.13191 8.50376C8.13191 10.6513 9.87262 12.392 12.0202 12.392ZM12.0202 14.2066C8.44035 14.2066 5.53809 15.3501 5.53809 16.7594C5.53809 18.1687 8.44035 19.3138 12.0202 19.3138C15.6 19.3138 18.5023 18.1703 18.5023 16.761C18.5023 15.3517 15.6 14.2066 12.0202 14.2066Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-patientInfo.svg
// module id = R6Cy
// module chunks = 111